import { css } from "@emotion/css";
import type { Properties } from "signlets";

import { classes } from "./classes";

const style = css`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.375rem;
  background: #ffffff22;
  border: 0.125rem solid transparent;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  transition: border-color 200ms;

  &:hover,
  &:has(input:focus) {
    border-color: white;
  }

  &:has(input:invalid) {
    border-color: #f66;
  }

  input {
    min-width: 0;
    width: auto;
    appearance: none;
    background: transparent;
    color: inherit;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: 1rem;
    font-variant: inherit;
    text-transform: none;

    ::placeholder {
      color: #fff5;
    }

    ::selection {
      background: black;
    }
  }
`;

export type FieldProps = {
  label: string;
  class?: string;
  children: JSX.Element;
};

export const Field = ({
  label,
  class: _class,
  children,
}: Properties<FieldProps>) => (
  <label class={classes(style, _class)}>
    {label}
    {children}
  </label>
);
